export enum HomeworkChoiceEnum {
    HOMEWORK = 'homework',
    READING = 'reading',
}
